import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SubSink } from "subsink";
import { MemberDetailService } from "./member-detail.service";
import { MemberStateService } from "./member-state.service";

@Component({
  selector: "member-member-detail",
  templateUrl: "./member-detail.component.html",
  styleUrls: ["./member-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberDetailComponent implements OnInit, OnDestroy {
  private sink = new SubSink();
  masterMemberId: number;
  dataSet: string;

  constructor(
    private memberDetailService: MemberDetailService,
    private memberStateService: MemberStateService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.masterMemberId = +params.get("masterMemberId");
      this.dataSet = params.get("activeGd");
    });

    if (!history.state.masterMemberId) {
      this.sink.add(
        this.memberDetailService.getArchiveMemberDetail(this.masterMemberId, this.dataSet).subscribe(state => {
          this.memberStateService.setData({
            ...state[0],
          });
        })
      );
    } else if (history.state.masterMemberId) {
      this.memberStateService.setData({
        ...history.state,
      });
    } else {
      this.router.navigateByUrl(`/chartlake/members`);
    }
  }

  ngOnDestroy() {
    this.memberStateService.clearData();
    this.sink.unsubscribe();
  }
}
